import { useNavigation } from "../../hooks/useNavigation";
import { View, Text, Card, Button } from "../base";

type AccountCardProps = {
  email: string | undefined;
};

export const AccountCard = ({ email }: AccountCardProps) => {
  const navigation = useNavigation();

  return (
    <Card className="p-6 relative">
      <View className="sm:pr-32">
        <Text className="text-lg font-semibold mb-4">Account Details</Text>
        <View className="flex flex-col gap-1">
          <Text
            variant="muted"
            className="text-sm"
          >
            Email Address
          </Text>
          <Text className="text-lg">{email}</Text>
        </View>
      </View>
      <View className="mt-4 sm:mt-0 sm:absolute sm:right-6 sm:top-1/2 sm:-translate-y-1/2">
        <Button
          onClick={() => navigation.navigate("/signout")}
          variant="outline"
          className="w-full sm:w-auto !text-red-600 !border-red-600 hover:!bg-red-50 dark:hover:!bg-red-950"
        >
          Sign out
        </Button>
      </View>
    </Card>
  );
};
